//import '../css/UserButton.css';
import {logUserButtonClick} from '../api/logUserButtonClick.js';
import '../css/Grid.css';

export const userButton = (userId, buttonId, url, text) => {
  const isLong = text.length > 41; // ✅ simple condition
  const classNames = `user-button${isLong ? " long-button" : ""}`;

 return (
  <a
    href={url}
    target="_self"
    rel="follow"
    className="button"
    onClick = {(e)=>logUserButtonClick(userId, buttonId, url)}
    >{text}
    </a>
    );
};


//export const logUserButtonClick = async (userId, buttonId) => {
